import { RestrictiveCourses } from "../generated/graphql"
import { InCommingAttributes } from "../types/filters"

export const handleRestrictiveCourses = (value: string | string[], updatedIncommingFilters: InCommingAttributes) => {
    let processedValue: string[]

    if (typeof value === "string") {
        processedValue = value.replace(/%20/g, "").replace(/ /g, "").split(",")
    } else if (Array.isArray(value)) {
        processedValue = value.map((str) => {
            if (typeof str === "string") {
                return str.replace(/%20/g, "").replace(/ /g, "")
            }
            return str
        })
    } else {
        // handle invalid input
        console.log("Invalid input for restrictiveCourses")
        return
    }

    // Function to check if an array contains only valid RestrictiveCourses values
    function isArrayConform(arr: string[]) {
        return arr.every((item) => Object.values(RestrictiveCourses).includes(item as RestrictiveCourses))
    }

    // Check if all elements in the array conform to the enum
    if (isArrayConform(processedValue)) {
        updatedIncommingFilters.restrictiveCourses = processedValue as Array<RestrictiveCourses>
    } else {
        console.log("Array contains invalid values for restrictiveCourses => ", processedValue)
    }

    // console.log("restrictiveCourses::: ", updatedIncommingFilters.restrictiveCourses)
}

export const handlePrerequisiteCourseId = (value: string, updatedIncommingFilters: InCommingAttributes) => {
    // Find all courses, that are bookable because of the prerequisite course
    let processedValue: string

    if (typeof value === "string") {
        processedValue = value.replace(/%20/g, "").replace(/ /g, "")

        updatedIncommingFilters.prerequisiteCourseId = processedValue
    } else {
        // handle invalid input
        console.log("Invalid input for prerequisiteCourseIds")
        return
    }
}
